module.exports = __webpack_public_path__ + "images/index/img06.a8a4792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/school/img06.jpg
// module id = dUi0
// module chunks = 21